

import { computed, defineComponent, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import Dropdown from 'primevue/dropdown';
import CatalogTypeConst from '../../../../../catalog/domain/const/CatalogTypeConst';
import helperCatalog from '../../../../../catalog/infrastructure/helper/helperCatalog';
import { Container } from 'inversify';
import { IServiceSearch } from '../../../../../search/application/IServiceSearch';
import { TYPES } from '../../../../../../../common/domain/types';
import HelperLoading from '../../../../../../../common/infrastructure/funciones/HelperLoading';
import CatalogDbType from '../../../../../catalog/domain/const/CatalogDbType';
import HelperCommon from '../../../../../../../common/infrastructure/funciones/HelperCommon';
import debounce from 'lodash.debounce';
import HelperCustomComponentControls from '../../../functions/helperCustomComponentControls';
import MessageNodeConst from '../constants/MessageNodeConst';
import Textarea from 'primevue/textarea';
//import PrimeVue from "primevue/config";
export default defineComponent({
    name: 'custommsgcontrol',
    components: {
        Dropdown,
        Textarea,
        //PrimeVue
    },
    props: {
        data: Object
    },
    setup(props) {
        const { showExpression } = HelperCustomComponentControls(props.data);
        const selectedMsg = ref('');
        const selectedMsgType = ref(1);
        const selectedMsgModalType = ref(true);
        const selectedMsgTypeData = ref([
            {id:1, description:'Info'},
            {id:2, description:'Error'},
            {id:3, description:'Aviso'},
            {id:4, description:'Correcto'},
            {id:5, description:'Pregunta'},
        ]);

        const selectedMsgModalTypeData = ref([
            {id:true, description:'Si'},
            {id:false, description:'No'},

        ]);


        let debounceUpdateData: any;
        const debounceTime = 1200;
       
    
        
  const initDebounce = () => {
    debounceUpdateData = debounce((data: any, start: boolean = false) => {
        if (props.data){
            props.data.onChange({ key: MessageNodeConst.VAR_MSG_IN, data: selectedMsg.value })        
        }
    }, debounceTime);
  }

  watch(
    selectedMsg, (newvalue, oldvalue) => {
          if (oldvalue !== newvalue && oldvalue !== undefined) {
              debounceUpdateData(newvalue, true);            
          }
        },
        {
          flush: 'post',
          //immediate: true, 
          deep: true
        }
      )


        onMounted(() => {
            if (props.data) {
                selectedMsg.value = props.data.variableMsgInput
                selectedMsgType.value = props.data.variableMsgInputType ?? 1
                selectedMsgModalType.value = props.data.variableMsgModalInput ?? true

            }
            initDebounce();
        })


        onBeforeUnmount(() => {
            debounceUpdateData.cancel();
        })
        return {
            selectedMsg,
            selectedMsgType,
            selectedMsgTypeData,
            selectedMsgModalTypeData,
            selectedMsgModalType,
            showExpression,
            MessageNodeConst
        };
    },
});
